/* tslint:disable */
/* eslint-disable */
/**
 * UI schemas for iDeed ARCGx v2.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ContractType } from './ContractType';
import {
    ContractTypeFromJSON,
    ContractTypeFromJSONTyped,
    ContractTypeToJSON,
} from './ContractType';

/**
 * 
 * @export
 * @interface QueryContract
 */
export interface QueryContract {
    /**
     * 
     * @type {ContractType}
     * @memberof QueryContract
     */
    ContractType?: ContractType;
    /**
     * 
     * @type {string}
     * @memberof QueryContract
     */
    criteria?: QueryContractCriteriaEnum;
    /**
     * 
     * @type {number}
     * @memberof QueryContract
     */
    limit?: number;
    /**
     * 
     * @type {number}
     * @memberof QueryContract
     */
    offset?: number;
}


/**
 * @export
 */
export const QueryContractCriteriaEnum = {
    lastActioned: 'lastActioned',
    expiringSoonest: 'expiringSoonest',
    largestValue: 'largestValue'
} as const;
export type QueryContractCriteriaEnum = typeof QueryContractCriteriaEnum[keyof typeof QueryContractCriteriaEnum];


/**
 * Check if a given object implements the QueryContract interface.
 */
export function instanceOfQueryContract(value: object): boolean {
    return true;
}

export function QueryContractFromJSON(json: any): QueryContract {
    return QueryContractFromJSONTyped(json, false);
}

export function QueryContractFromJSONTyped(json: any, ignoreDiscriminator: boolean): QueryContract {
    if (json == null) {
        return json;
    }
    return {
        
        'ContractType': json['ContractType'] == null ? undefined : ContractTypeFromJSON(json['ContractType']),
        'criteria': json['criteria'] == null ? undefined : json['criteria'],
        'limit': json['limit'] == null ? undefined : json['limit'],
        'offset': json['offset'] == null ? undefined : json['offset'],
    };
}

export function QueryContractToJSON(value?: QueryContract | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'ContractType': ContractTypeToJSON(value['ContractType']),
        'criteria': value['criteria'],
        'limit': value['limit'],
        'offset': value['offset'],
    };
}

